import { render } from "./PersonCard.vue?vue&type=template&id=c848b444&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"

import "./PersonCard.vue?vue&type=style&index=0&id=c848b444&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c848b444"]])

export default __exports__